import React from "react";
import TextField from "@material-ui/core/TextField";
import { Box } from "@material-ui/core";

export const ColorPicker = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
    editable,
) => {
    const handleChange = (e) => {
        const hexValue = e.target.value.toUpperCase();
        fieldUpdateHandler(name, hexValue);
    };

    return (
        <Box width={"45%"}>
            <input
                type="color"
                value={value}
                onChange={handleChange}
                style={{
                    width: "200px",
                    height: "50px",
                    cursor: "pointer",
                    border: "none",
                }}
            />
            {!!isError && <TextField error={!!isError} helperText={isError} />}
        </Box>
    );
};
